import { render, staticRenderFns } from "./KeybeSidebar.vue?vue&type=template&id=2ad41276&scoped=true&"
import script from "./KeybeSidebar.vue?vue&type=script&lang=ts&"
export * from "./KeybeSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeSidebar.vue?vue&type=style&index=0&id=2ad41276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad41276",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VChip,VHover,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu})
